import NAVIGATION_TYPE from '@src/quince-site-common/src/constants/navigationType'

import { TextWithImageCarousel, TextWithImageCarouselProps } from './TextWithImageCarousel'

export default TextWithImageCarousel

export { type TextWithImageCarouselProps, TextWithImageCarousel, NAVIGATION_TYPE }
